import React from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { Helmet } from "react-helmet";
import web5 from "../img/Outsourcing.jpg";

const Outsourcing = () => {
  const heroWrap = {
    borderRadius: 18,
    border: "1px solid #e8eef7",
    boxShadow: "0 18px 44px rgba(15, 23, 42, 0.10)",
    overflow: "hidden",
    position: "relative",
    backgroundImage: `url(${web5})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const heroOverlay = {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(90deg, rgba(2,6,23,0.88) 0%, rgba(2,6,23,0.60) 45%, rgba(2,6,23,0.22) 100%)",
  };

  const heroContent = {
    position: "relative",
    padding: "38px 28px",
    maxWidth: 920,
    color: "#ffffff",
  };

  const pill = {
    display: "inline-block",
    padding: "8px 14px",
    borderRadius: 999,
    background: "rgba(255,255,255,0.14)",
    border: "1px solid rgba(255,255,255,0.25)",
    fontWeight: 800,
    fontSize: 12,
    letterSpacing: "0.4px",
    marginBottom: 12,
  };

  const sectionCard = {
    borderRadius: 16,
    border: "1px solid #eef2f7",
    boxShadow: "0 10px 24px rgba(0,0,0,0.06)",
  };

  const sectionTitle = {
    fontWeight: 900,
    color: "#0f172a",
    marginBottom: 8,
  };

  const divider = {
    width: 70,
    height: 4,
    borderRadius: 12,
    background: "#ff6a00",
    marginBottom: 16,
  };

  const para = {
    lineHeight: 1.9,
    color: "#1f2937",
    fontSize: "1.02rem",
    textAlign: "justify",
    marginBottom: 14,
  };

  return (
    <>
      {/* ✅ SEO */}
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Software Outsourcing Services in India | EBS Software Solution
        </title>
        <meta
          name="description"
          content="EBS Software Solution provides reliable offshore software outsourcing services in India. We deliver cost-effective, scalable and high-quality software development with strong project management."
        />
        <meta
          name="keywords"
          content="Software Outsourcing India, Offshore Software Development, IT Outsourcing Company India, Custom Software Outsourcing, Enterprise Software Services"
        />
      </Helmet>

      {/* ✅ HERO */}
      <Container className="py-3">
        <div style={heroWrap}>
          <div style={heroOverlay} />
          <div style={heroContent}>
            <div style={pill}>OFFSHORE DEVELOPMENT • OUTSOURCING</div>

            <h1 style={{ fontWeight: 900, fontSize: "clamp(32px,4vw,44px)" }}>
              Software Outsourcing
            </h1>

            <p style={{ maxWidth: 760, lineHeight: 1.7, fontWeight: 600 }}>
              Reliable offshore software development services designed to reduce
              cost, improve efficiency, and help businesses focus on their core
              competencies.
            </p>

            <div className="d-flex gap-2 flex-wrap mt-2">
              <Badge bg="light" text="dark" style={{ fontWeight: 800, padding: "10px 12px" }}>
                Offshore Development
              </Badge>
              <Badge bg="light" text="dark" style={{ fontWeight: 800, padding: "10px 12px" }}>
                Cost Optimization
              </Badge>
              <Badge bg="light" text="dark" style={{ fontWeight: 800, padding: "10px 12px" }}>
                Dedicated Teams
              </Badge>
            </div>
          </div>
        </div>
      </Container>

      {/* ✅ CONTENT */}
      <Container className="py-4">
        <Row className="g-4">
          <Col lg={12}>
            <Card style={sectionCard}>
              <Card.Body style={{ padding: 22 }}>
                <h2 style={sectionTitle}>Why Software Outsourcing?</h2>
                <div style={divider} />

                <p style={para}>
                  In today’s global economy, software outsourcing has become a
                  strategic business decision rather than just a cost-saving
                  measure. Organizations now outsource to gain competitive
                  advantage, accelerate delivery timelines, and access skilled
                  talent while focusing on their core business objectives.
                </p>

                <p style={para}>
                  EBS Software Solution, based in India, specializes in offshore
                  software development that is efficient, reliable, and
                  cost-effective. Our structured development processes, strict
                  quality standards, and experienced project management ensure
                  consistent and predictable outcomes.
                </p>

                <p style={para}>
                  With extensive experience across multiple industries, we
                  deliver tailored software solutions that align with your
                  business goals. Our global outsourcing approach ensures
                  transparency, accountability, and long-term value.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* ✅ KEY BENEFITS */}
        <Row className="mt-4 g-4">
          {[
            {
              title: "Cost-Effective Delivery",
              text:
                "Reduce operational and development costs without compromising on quality or performance.",
            },
            {
              title: "Access to Skilled Talent",
              text:
                "Work with experienced engineers and domain experts across multiple technologies.",
            },
            {
              title: "Faster Time-to-Market",
              text:
                "Accelerate development cycles with dedicated offshore teams and agile methodologies.",
            },
            {
              title: "Strong Project Management",
              text:
                "Well-defined processes, milestones, reporting, and communication.",
            },
            {
              title: "Scalable Engagement Models",
              text:
                "Flexible outsourcing models that grow with your business needs.",
            },
            {
              title: "Quality & Security Focus",
              text:
                "Strict quality assurance and data security standards at every stage.",
            },
          ].map((item, idx) => (
            <Col key={idx} md={6} lg={4}>
              <Card style={sectionCard} className="h-100">
                <Card.Body style={{ padding: 18 }}>
                  <h5 style={{ fontWeight: 900, color: "#0f172a" }}>
                    {item.title}
                  </h5>
                  <p style={{ marginBottom: 0, color: "#334155", lineHeight: 1.7 }}>
                    {item.text}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* ✅ CTA */}
        <Row className="mt-4">
          <Col lg={12}>
            <Card
              style={{
                ...sectionCard,
                background: "linear-gradient(135deg, #ffffff 0%, #f6f9ff 100%)",
              }}
            >
              <Card.Body style={{ padding: 20 }}>
                <h4 style={{ fontWeight: 900, color: "#0f172a" }}>
                  Looking for a Reliable Outsourcing Partner?
                </h4>
                <p style={{ ...para, marginBottom: 0 }}>
                  Partner with EBS Software Solution for dependable offshore
                  software development services that deliver measurable business
                  value with long-term support.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Outsourcing;
